import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import HomePage from "./pages/Home";
import ProjectsPage from "./pages/Projects";
import AboutPage from "./pages/About";
import ProcessPage from "./pages/Process";
import ServicesPage from "./pages/Services";
import ContactPage from "./pages/Contact";
import PrivacyPage from "./pages/Privacy";

const PageFade = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageFade>
              <HomePage />
            </PageFade>
          }
        />
        <Route
          path="/projects"
          element={
            <PageFade>
              <ProjectsPage />
            </PageFade>
          }
        />
        <Route path="/projects/:slug" element={<Navigate to="/projects" replace />} />
        <Route
          path="/about"
          element={
            <PageFade>
              <AboutPage />
            </PageFade>
          }
        />
        <Route
          path="/process"
          element={
            <PageFade>
              <ProcessPage />
            </PageFade>
          }
        />
        <Route
          path="/services"
          element={
            <PageFade>
              <ServicesPage />
            </PageFade>
          }
        />
        <Route
          path="/contact"
          element={
            <PageFade>
              <ContactPage />
            </PageFade>
          }
        />
        <Route
          path="/privacy"
          element={
            <PageFade>
              <PrivacyPage />
            </PageFade>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App bg-zinc-950 text-zinc-100 min-h-screen">
      <BrowserRouter>
        <Navbar />
        <main>
          <AnimatedRoutes />
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
